import z from 'zod';

import { isValidABN } from './is-valid-abn';

export const StringRequiredSchema = (message: string) =>
  z.string().min(1, message);

export const NumberRequiredSchema = (
  message: string,
  numberSchema:
    | z.ZodNumber
    | z.ZodEffects<z.ZodNumber, number, number> = z.number(),
) =>
  z.union([
    numberSchema,
    z.null().refine((value) => Number.isFinite(value), message),
  ]);

export const IsValidABNSchema = (
  message: string = 'Please enter a valid ABN.',
) =>
  StringRequiredSchema(message).refine((value) => isValidABN(value), message);
